import { useMemo } from "react";
const ReactionsList = ({ reactions = [], onClick }) => {
  const { grouped } = useMemo(() => {
    const grouped = reactions.reduce((acc, { emoji, ...rest }) => {
      (acc[emoji] ||= []).push({ emoji, ...rest });
      return acc;
    }, {});

    return { grouped };
  }, [reactions]);

  return (
    <>
      <div className="reactions-bar">
        {reactions.length > 0 && (
          <div className="reaction-bubble" onClick={onClick}>
            {Object.keys(grouped).map((emoji) => (
              <span key={emoji} className="reaction-emoji">
                {emoji}
              </span>
            ))}
            <span className="reaction-count">{reactions.length}</span>
          </div>
        )}
      </div>
    </>
  );
};

export default ReactionsList;
